import { cmsCLient } from '@/services/axiosConfig'
import { SpecialOffer } from '../home-page-content/types'

export type GetNewsRes = SpecialOffer[]

export type GetNews = () => Promise<GetNewsRes>

export const getNews: GetNews = async () => {
  try {
    const response = await cmsCLient.get('/contents/news/list')
    return response.data
  } catch (e: any) {
    return e.message
  }
}

export type GetNewsDetailsRes = SpecialOffer

export type GetNewsDetails = (id: string | string[] | undefined) => Promise<GetNewsDetailsRes>

export const getNewsDetails: GetNewsDetails = async (id) => {
  try {
    let param: string
    if (id !== undefined) {
      if (Array.isArray(id)) {
        param = id[0]
      } else {
        param = id
      }
      const response = await cmsCLient.get('/contents/news?id=' + param)
      return response.data
    }
  } catch (e: any) {
    return e.message
  }
}
